import PropTypes from 'prop-types';
import React from 'react';

import Alert from '@mui/material/Alert';

export default function ChooseMfaFactor(props) {
  const t = props.context.t;
  const [error, setError] = React.useState(null);
  const [busy, setBusy] = React.useState(false);

  const pick = (hint) => {
    setError(null);
    setBusy(true);
    props.onSelect(hint, (err) => {
      setBusy(false);
      if (err) {
        setError(err.message || t('invalid_code'));
      }
    });
  };

  return (
    <div className='login-input-field mfa-enroll'>
      <h2 style={{ fontSize: '20px', borderBottom: '1px solid' }}>
        {t('multifactor_authentication')}
      </h2>

      {error && (
        <Alert className='mfa-error' severity='error'>
          {error}
        </Alert>
      )}

      <p>{t('choose_mfa_factor')}</p>
      <div className='form-group form-actions'>
        <div className='col-xs-6 col-xs-offset-3 login-field'>
          {props.hints.map((hint) => (
            <button
              key={hint.uid}
              className='login-submit btn btn-success btn-block'
              disabled={busy}
              onClick={() => pick(hint)}
            >
              {hint.factorId === 'phone'
                ? `${t('mfa_method_sms')} ${hint.phoneNumber || ''}`
                : t('mfa_method_totp')}
            </button>
          ))}
        </div>
      </div>
      <div className='mfa-links'>
        <a href='#' onClick={() => props.backTo('signIn')}>
          {t('cancel')}
        </a>
      </div>
    </div>
  );
}

ChooseMfaFactor.propTypes = {
  backTo: PropTypes.func.isRequired,
  context: PropTypes.object.isRequired,
  hints: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
};
